export const DISCORD_CONTEXT_MAX_MESSAGES_KEY = "context_max_messages";
export const DEFAULT_DISCORD_CONTEXT_MAX_MESSAGES = 20;
export const MIN_DISCORD_CONTEXT_MAX_MESSAGES = 2;
export const MAX_DISCORD_CONTEXT_MAX_MESSAGES = 100;

export interface DiscordContextPolicy {
  context_max_messages: number;
  half_window_messages: number;
}

export function isDiscordContextMaxMessages(value: unknown): value is number {
  return typeof value === "number"
    && Number.isSafeInteger(value)
    && value >= MIN_DISCORD_CONTEXT_MAX_MESSAGES
    && value <= MAX_DISCORD_CONTEXT_MAX_MESSAGES;
}

export function parseDiscordContextMaxMessages(value: unknown): number {
  const parsed = typeof value === "string" && /^\d+$/.test(value)
    ? Number(value)
    : value;
  if (!isDiscordContextMaxMessages(parsed)) {
    throw new Error("discord_context_max_messages_invalid");
  }
  return parsed;
}

export function resolveDiscordContextPolicy(system: Readonly<Record<string, unknown>>): DiscordContextPolicy {
  const stored = system[DISCORD_CONTEXT_MAX_MESSAGES_KEY];
  const contextMaxMessages = stored === undefined
    ? DEFAULT_DISCORD_CONTEXT_MAX_MESSAGES
    : parseDiscordContextMaxMessages(stored);
  return {
    context_max_messages: contextMaxMessages,
    // 兼容旧客户端的响应字段；回复链追索不再使用半窗滚动压缩语义。
    half_window_messages: Math.floor(contextMaxMessages / 2),
  };
}
